if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {        
        spaceBetween: 0,
        centeredSlides: true,
        speed: 7000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false
      });
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
